import React from 'react';
import { CreditCardIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { finalCtaBadges, finalCtaCopy, offer } from '../data/content';
interface FinalCtaCopy {
  title: string;
  subtitle: string;
  summary: string;
  cta: string;
}
interface FinalCtaProps {
  copy?: FinalCtaCopy;
}
export function FinalCta({
  copy = finalCtaCopy
}: FinalCtaProps) {
  return <section className="w-full bg-white py-14 md:py-20" data-id="element-68" data-mp="1jcd5md9gm4dl">
      <div className="mx-auto w-full max-w-5xl px-5 md:px-8" data-id="element-69" data-mp="1jasbupuyypgs">
        <div className="mx-auto max-w-3xl text-center" data-id="element-70" data-mp="1edipjj2vmtx6">
          <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-slate-900 md:text-5xl" data-id="element-71" data-mp="1t2ojariy3rxo">
            {copy.title}
          </h2>
          <p className="mx-auto mt-5 max-w-2xl text-lg text-blue-900/75" data-id="element-72" data-mp="1o4dbsng4htim">{copy.subtitle}</p>
        </div>

        <div className="mx-auto mt-10 max-w-lg rounded-2xl bg-white p-6 text-center shadow-lg ring-2 ring-blue-600 sm:p-8" data-id="element-73" data-mp="223w90l7ebkg5">
          <h3 className="text-lg font-extrabold uppercase leading-snug tracking-tight text-slate-900" data-id="element-74" data-mp="1x2p2epgzorb2">
            {offer.name}
          </h3>
          <p className="mt-1 font-semibold text-blue-600" data-id="element-75" data-mp="s5qopxrp58uq">{copy.summary}</p>
          <p className="mt-5 text-5xl font-extrabold tracking-tight text-slate-900" data-id="element-76" data-mp="x38zzut6s05w">
            {offer.price}
            <span className="ml-2 text-lg font-semibold text-blue-900/55" data-id="element-77" data-mp="12354dv5sptlz">{offer.currency}</span>
          </p>
          <div className="mt-6" data-id="element-78" data-mp="163fb5a1ewo1w">
            <CtaButton size="lg" className="w-full" data-id="element-79" data-mp="1646wls1ap5eg">
              {copy.cta}
            </CtaButton>
          </div>
          <ul className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-sm font-medium text-blue-900/70" data-id="element-80" data-mp="1b171hzmes23z">
            <li className="inline-flex items-center gap-1.5" data-id="element-81" data-mp="1ktw8oiaxetti">
              <ZapIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-82" data-mp="1kv7dmlg3y7m7" />{' '}
              {finalCtaBadges.access}
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-83" data-mp="1ttj9b1vtzvli">
              <CreditCardIcon className="h-4 w-4 text-blue-600" aria-hidden="true" data-id="element-84" data-mp="1tropxs07kbjj" />{' '}
              {finalCtaBadges.payment}
            </li>
            <li className="inline-flex items-center gap-1.5" data-id="element-85" data-mp="3lwdoin4k2p88">
              <ShieldCheckIcon className="h-4 w-4 text-emerald-500" aria-hidden="true" data-id="element-86" data-mp="3hl4t588aabk" />{' '}
              {finalCtaBadges.guarantee}
            </li>
          </ul>
        </div>
      </div>
    </section>;
}